// Copyright (c) Docugami, Inc. All rights reserved.

import { TierOption, useGetSubscriptionTiersQuery } from "billing/BillingService";
import { useState, useEffect } from "react";

interface IBillingTiers {
    tiers: TierOption[];
    isLoading: boolean;
}

export function useBillingTiers(): IBillingTiers {
    const [billingTiers, setBillingTiers] = useState<TierOption[]>();
    const { isLoading, data, isSuccess } = useGetSubscriptionTiersQuery();

    useEffect(() => {
        if (!!isSuccess && !!data) {
            setBillingTiers(data);
        }
    }, [isSuccess, data])

    return {
        tiers: billingTiers ?? [],
        isLoading: isLoading
    }
}